export const SUPPORT_EMAIL = 'creatorcv.app@gmail.com';
export const INSTAGRAM_HANDLE = '@creatorcv.app';
export const INSTAGRAM_URL = 'https://www.instagram.com/creatorcv.app/';
